import { ArrowLinkText } from '@/components/common/ArrowLinkText';
import { FlexRow } from '@/components/common/Flex';
import { Paragraph, Title } from '@/components/common/Typography';
import { Box, BoxProps } from '@chakra-ui/react';
import { labelByAvoidIndustry, labelBySupportedValue } from '@common/inputs';
import { useCurrentUser } from '@common/react/user';
import styleguide from '@common/styleguide';
import { useRouter } from 'next/router';
import React from 'react';
import { FlexCol } from '../common/Flex';
import { CheckCircle, XClose } from '../common/icons';

export default function InvestmentValuesSection({ ...props }: BoxProps) {
    const router = useRouter();
    const { userInfo } = useCurrentUser();

    const supportedValues = (
        userInfo.investmentProfile?.supported_values || []
    ).map((v) => labelBySupportedValue[v]);

    const avoidIndustries = (
        userInfo.investmentProfile?.avoid_industries || []
    ).map((v) => labelByAvoidIndustry[v]);

    const values = supportedValues.length + avoidIndustries.length;
    return (
        <Box {...props}>
            <Paragraph mb={5} lineHeight={1}>
                <Title fontWeight="medium" as="span" mr={1}>
                    {values}
                </Title>{' '}
                values-aligned
            </Paragraph>
            <FlexRow color="textMuted" mb={3}>
                {supportedValues.length > 0 && (
                    <FlexCol flexGrow={1}>
                        {supportedValues.map((s) => (
                            <FlexRow key={s} alignItems="center" mb={1}>
                                <CheckCircle
                                    size="sm"
                                    color={styleguide.colors.greenBright}
                                    mr={1}
                                />
                                <Paragraph fontSize="sm" flexGrow={1}>
                                    {s}
                                </Paragraph>
                            </FlexRow>
                        ))}
                    </FlexCol>
                )}
                <FlexCol flexGrow={1}>
                    {avoidIndustries.map((s) => (
                        <FlexRow key={s} alignItems="center" mb={1}>
                            <XClose
                                size="sm"
                                color={styleguide.colors.redLight}
                                mr={1}
                            />
                            <Paragraph fontSize="sm" flexGrow={1}>
                                {s}
                            </Paragraph>
                        </FlexRow>
                    ))}
                </FlexCol>
            </FlexRow>
            <ArrowLinkText
                onClick={() => router.push('/profile#investment-profile')}
            >
                Change values
            </ArrowLinkText>
        </Box>
    );
}
